import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { T } from "@/constants/testIds";

export default function Hero() {
  return (
    <section
      data-testid={T.heroSection}
      className="relative overflow-hidden border-b border-border"
    >
      {/* Faint brand watermark behind the text column */}
      <LogoMark className="absolute -top-24 -left-28 h-[360px] w-auto opacity-[0.025] pointer-events-none text-ink" />

      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 py-16 sm:py-24 lg:py-28 items-center relative">
        <div className="lg:col-span-7 relative lg:pr-8">
          <div className="flex items-center gap-3 animate-fade-up">
            <span className="divider-gold" />
            <span className="eyebrow text-gold-dark">“I am the way, the truth, and the life” — John 14:6</span>
          </div>
          <h1 className="heading-display mt-7 animate-fade-up" style={{ animationDelay: "0.1s" }}>
            What is{" "}
            <span className="relative inline-block">
              <em className="italic text-gold-dark">eternal life</em>
              <span className="absolute left-0 -bottom-1 h-[3px] w-full bg-gold/40" aria-hidden />
            </span>
            ?
          </h1>
          <p className="font-hindi text-2xl sm:text-3xl text-ink-soft mt-4 animate-fade-up" style={{ animationDelay: "0.2s" }} data-no-translate>
            अनन्त जीवन क्या है?
          </p>
          <p className="lead mt-7 max-w-xl animate-fade-up" style={{ animationDelay: "0.3s" }}>
            Discover the life, forgiveness, and hope God offers through Jesus Christ — explained gently, honestly, and
            rooted in the Bible.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-fade-up" style={{ animationDelay: "0.4s" }}>
            <Link data-testid={T.heroPrimaryCta} to="/eternal-life" className="btn-gold">
              Discover Eternal Life <ArrowRight className="h-4 w-4" />
            </Link>
            <Link data-testid={T.heroSecondaryCta} to="/start-here" className="btn-ghost">
              I am new to Christianity
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative">
            {/* Gold frame offset behind the image */}
            <span className="absolute -top-4 -right-4 w-full h-full border border-gold/50 pointer-events-none" aria-hidden />
            <img
              src="https://images.unsplash.com/photo-1771758265715-940a38947f28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="A person reading the Bible by a sunlit window"
              className="relative w-full h-[420px] sm:h-[520px] object-cover"
              loading="eager"
              width="1200"
              height="900"
            />
            <div className="absolute -bottom-8 -left-6 sm:-left-12 bg-paper border border-border p-6 sm:p-7 max-w-xs shadow-[0_30px_70px_-30px_rgba(15,23,42,0.45)]">
              <p className="eyebrow text-gold-dark flex items-center gap-2">
                <span className="h-px w-5 bg-gold" />
                Featured verse
              </p>
              <p className="font-serif text-xl italic text-ink mt-3 leading-snug">
                “This is eternal life, that they know You, the only true God, and Jesus Christ whom You have sent.”
              </p>
              <p className="text-xs text-ink-muted mt-3">John 17:3 · KJV (public domain)</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
